import * as tslib_1 from "tslib";
import { OnInit, DoCheck } from '@angular/core';
import { AirportService } from '../airport.service';
import { Airport } from '../models/airport.model';
import { getEveryIntercardinalDirection } from '../../util/geodesy/helpers';
var DistanceCalculatorComponent = /** @class */ (function () {
    function DistanceCalculatorComponent(_airports) {
        this._airports = _airports;
        this.showCalculation = false;
        this.showFromBlank = true;
        this.showToBlank = false;
        this.showFromProcessing = false;
        this.showToProcessing = false;
    }
    DistanceCalculatorComponent.prototype.ngOnInit = function () {
        this.oldAirport = this.airport;
        this.toAirport = this.airport;
    };
    DistanceCalculatorComponent.prototype.ngDoCheck = function () {
        /* This hack is to handle routes coming from the autocomplete search.
          * Without it, an airport manager would look like they could manage airports they don't have permission to manage.
          * The API prevents any actual changes regardless of what the interface shows without this hack. */
        if (this.airport && this.oldAirport && this.airport.airportId !== this.oldAirport.airportId) {
            this.oldAirport = this.airport;
            this.toAirport = this.airport;
            this.reset();
            this.showToBlank = false;
        }
    };
    DistanceCalculatorComponent.prototype.calculateDistance = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, dirResult;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.showFromBlank = false;
                        this.showToBlank = false;
                        this.showCalculation = true;
                        _a = this;
                        return [4 /*yield*/, this._airports.getAirport($('#DistanceFrom').val().toString(), true)];
                    case 1:
                        _a.fromAirport = _c.sent();
                        _b = this;
                        return [4 /*yield*/, this._airports.getAirport($('#DistanceTo').val().toString(), true)];
                    case 2:
                        _b.toAirport = _c.sent();
                        if (this.toAirport != null && this.fromAirport != null) {
                            this.distance = Math.round(this.toAirport.location.distanceTo(this.fromAirport.location) / 1852 * 10) / 10;
                            dirResult = this.fromAirport.location.vincentyInverse(this.toAirport.location);
                            this.direction = getEveryIntercardinalDirection(dirResult.initialBearing);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    DistanceCalculatorComponent.prototype.planFlightClick = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, allAirportIdsValidOrBlank, fromAirportId, toAirportId, url;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this._airports.getAirport($('#DistanceFrom').val().toString(), true)];
                    case 1:
                        _a.fromAirport = _c.sent();
                        _b = this;
                        return [4 /*yield*/, this._airports.getAirport($('#DistanceTo').val().toString(), true)];
                    case 2:
                        _b.toAirport = _c.sent();
                        allAirportIdsValidOrBlank = ((this.toAirport != null || this.showToBlank) && (this.fromAirport != null || this.showFromBlank));
                        if (allAirportIdsValidOrBlank) {
                            fromAirportId = this.fromAirport != null ? this.fromAirport.faaId : '';
                            toAirportId = this.toAirport != null ? this.toAirport.faaId : '';
                            url = "https://iflightplanner.aopa.org/My/Trip/?From=" + fromAirportId + "&To=" + toAirportId;
                            window.open(url, '_blank').focus();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    DistanceCalculatorComponent.prototype.onBlurFromIdent = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.showFromProcessing = true;
                        this.showFromBlank = false;
                        this.showCalculation = false;
                        _a = this;
                        return [4 /*yield*/, this._airports.getAirport($('#DistanceFrom').val().toString(), true)];
                    case 1:
                        _a.fromAirport = _b.sent();
                        this.showFromProcessing = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    DistanceCalculatorComponent.prototype.onBlurToIdent = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.showToProcessing = true;
                        this.showToBlank = false;
                        this.showCalculation = false;
                        _a = this;
                        return [4 /*yield*/, this._airports.getAirport($('#DistanceTo').val().toString(), true)];
                    case 1:
                        _a.toAirport = _b.sent();
                        this.showToProcessing = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    DistanceCalculatorComponent.prototype.reset = function () {
        $('#DistanceFrom').val('');
        $('#DistanceTo').val(this.airport.identifier);
        this.showCalculation = false;
        this.showFromBlank = true;
        this.showToBlank = true;
    };
    return DistanceCalculatorComponent;
}());
export { DistanceCalculatorComponent };
